/* eslint-disable promise/prefer-await-to-callbacks */
import axios, { AxiosInstance } from 'axios';
import injectAuthorization from './injectAuthorization';
import injectNetworkErrorNotifier from './injectNetworkErrorNotifier';

/**
 * An instance of a network client that handles transactions with the
 * authentication service.
 */
const AuthNetworkClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_LOGIN,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
    scope: 'sales-journey-ms openid IdentityServerApi',
  },
});

AuthNetworkClient.interceptors.request.use(injectAuthorization);
AuthNetworkClient.interceptors.response.use(
  (response) => response,
  (error) => {
    injectNetworkErrorNotifier(error);

    // Rethrow the error, so that processRequest can catch it
    throw error;
  },
);

export default AuthNetworkClient;
